/* Percorso guidato — Lady&Oscar
   Legge l'albero dal tag <script type="application/json"> (snippets/percorso-albero)
   e disegna una domanda alla volta. Nessuna dipendenza esterna. */

(function () {
  'use strict';

  function init(root) {
    if (root.dataset.pgReady === '1') return;
    root.dataset.pgReady = '1';

    var dataEl = root.querySelector('[data-pg-data]');
    var trailEl = root.querySelector('[data-pg-trail]');
    var questionEl = root.querySelector('[data-pg-question]');
    var gridEl = root.querySelector('[data-pg-grid]');
    var backEl = root.querySelector('[data-pg-back]');
    if (!dataEl || !gridEl) return;

    var tree;
    try {
      tree = JSON.parse(dataEl.textContent);
    } catch (e) {
      return; // JSON malformato: la sezione resta vuota invece di rompere la pagina
    }

    var path = []; // array di nodi attraversati

    function currentNode() {
      return path.length ? path[path.length - 1] : tree;
    }

    function slugsCorrenti() {
      return path.map(function (s) { return s.id; }).filter(Boolean);
    }

    // Aggiunge il ramo percorso alla destinazione, cosi' la pagina di arrivo
    // puo' mostrare la barra di ritorno (snippets/percorso-ritorno).
    function destinazione(opt) {
      var slugs = slugsCorrenti();
      if (opt.id) slugs.push(opt.id);
      if (!slugs.length) return opt.url;
      var sep = opt.url.indexOf('?') === -1 ? '?' : '&';
      return opt.url + sep + 'pg=' + encodeURIComponent(slugs.join('/'));
    }

    function render(focusFirst) {
      var node = currentNode();
      var options = node.options || [];

      questionEl.textContent = node.question || '';

      // Briciole di pane
      trailEl.innerHTML = '';
      if (path.length) {
        var home = document.createElement('button');
        home.type = 'button';
        home.className = 'pg__crumb';
        home.textContent = tree.home || 'Inizio';
        home.addEventListener('click', function () {
          path = [];
          render(true);
          writeHash();
        });
        trailEl.appendChild(home);

        path.forEach(function (step, i) {
          var sep = document.createElement('span');
          sep.className = 'pg__sep';
          sep.textContent = '›';
          trailEl.appendChild(sep);

          var isLast = i === path.length - 1;
          var crumb = document.createElement('button');
          crumb.type = 'button';
          crumb.className = 'pg__crumb' + (isLast ? ' pg__crumb--current' : '');
          crumb.textContent = step.label;
          if (isLast) {
            crumb.setAttribute('aria-current', 'step');
            crumb.disabled = true;
          } else {
            crumb.addEventListener('click', function () {
              path = path.slice(0, i + 1);
              render(true);
              writeHash();
            });
          }
          trailEl.appendChild(crumb);
        });
      }

      // Profondità della domanda corrente: 0 = prima schermata.
      // Il CSS la usa per nascondere gli aiuti su mobile solo al primo livello,
      // dove le etichette si spiegano da sole e servono tasti bassi.
      gridEl.dataset.livello = String(path.length);

      // Scelte
      gridEl.innerHTML = '';
      options.forEach(function (opt) {
        var isLeaf = !!opt.url;
        var el = document.createElement(isLeaf ? 'a' : 'button');

        if (isLeaf) {
          el.href = destinazione(opt);
        } else {
          el.type = 'button';
        }
        el.className = 'pg__card' + (isLeaf ? ' pg__card--leaf' : '');

        var label = document.createElement('span');
        label.className = 'pg__card-label';
        label.textContent = opt.label;
        el.appendChild(label);

        if (opt.hint) {
          var hint = document.createElement('span');
          hint.className = 'pg__card-hint';
          hint.textContent = opt.hint;
          el.appendChild(hint);
        }

        if (!isLeaf) {
          el.addEventListener('click', function () {
            path.push(opt);
            render(true);
            writeHash();
          });
        }

        gridEl.appendChild(el);
      });

      backEl.hidden = path.length === 0;

      if (focusFirst) {
        var first = gridEl.querySelector('.pg__card');
        if (first && document.activeElement !== document.body) first.focus();
      }
    }

    function writeHash() {
      if (!root.dataset.pgHash) return;
      var slugs = slugsCorrenti();
      if (history.replaceState) {
        history.replaceState(
          null,
          '',
          slugs.length ? '#percorso=' + slugs.join('/') : location.pathname + location.search
        );
      }
    }

    function readHash() {
      var m = /[#&]percorso=([^&]+)/.exec(location.hash);
      if (!m) return;
      var slugs = decodeURIComponent(m[1]).split('/');
      var node = tree;
      var found = [];
      for (var i = 0; i < slugs.length; i++) {
        var next = (node.options || []).filter(function (o) { return o.id === slugs[i]; })[0];
        if (!next || next.url) break;
        found.push(next);
        node = next;
      }
      path = found;
    }

    // Si arriva alla home con un ramo nell'indirizzo (dalla barra di ritorno di
    // una collezione, o da un link diretto): la pagina si aprirebbe in cima e
    // sembrerebbe di essere solo tornati alla home. Portiamo il blocco sotto gli
    // occhi, ma senza mai combattere con l'utente: al primo gesto di scorrimento
    // suo, smettiamo.
    function portaAlBlocco() {
      var fermo = false;
      function segna() { fermo = true; }
      ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
        window.addEventListener(ev, segna, { once: true, passive: true });
      });

      function vai() {
        if (fermo) return;
        var y = root.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo(0, y > 0 ? y : 0);
      }

      requestAnimationFrame(vai);
      setTimeout(vai, 400);
      window.addEventListener('load', function () { setTimeout(vai, 120); });
    }

    backEl.addEventListener('click', function () {
      path.pop();
      render(true);
      writeHash();
    });

    readHash();
    render(false);
    if (path.length) portaAlBlocco();
  }

  function boot() {
    document.querySelectorAll('[data-pg]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Editor del tema: ridisegna quando la sezione viene ricaricata
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-pg]');
    if (el) init(el);
  });
})();